import React, { createContext, useContext } from "react";
import { useSettings, defaultSettings, IUseSettingsHook } from "../hooks/useSettings";

const defaultValue = {
    settings: defaultSettings,
    setSetting: () => { }
}
const context = createContext<ReturnType<IUseSettingsHook>>(defaultValue);
const { Provider } = context;

export const useSettingsContext = () => useContext(context);

// Provider
export const SettingsProvider: React.FC = ({ children }) => {
    const settingsData = useSettings();
    return (
        <Provider value={settingsData}>
            {children}
        </Provider>
    );
};
